module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-1-4a100753e72906714e94ee3c80cf2ed6.webp";